import type { ImportSetting } from '../@types/ImportSetting';
import type { Actions } from '../actions';
import { REQ_BRANCH } from '../actions/branch';
import {
  RCV_CREATE_IMPORT_SETTING,
  RCV_IMPORT_SETTING_LIST,
  RCV_MATCH_IMPORT_SETTING,
  RCV_REMOVE_IMPORT_SETTING,
  RCV_UPDATE_IMPORT_SETTING,
  REQ_CREATE_IMPORT_SETTING,
  REQ_IMPORT_SETTING_LIST,
  REQ_MATCH_IMPORT_SETTING,
  REQ_REMOVE_IMPORT_SETTING,
  REQ_UPDATE_IMPORT_SETTING,
  REQUEST_FAILED,
} from '../actions/import-setting';
import { requestStatus, responseStatus } from '../shared/statuses';

interface ImportSettingsState {
  requestStatus: number;
  responseStatus: number;
  list: ImportSetting[];
  matches: ImportSetting[];
}

const _initialState: ImportSettingsState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  list: [],
  matches: [],
};

const importsettingsReducer = (
  state: ImportSettingsState = _initialState,
  action: Actions,
): ImportSettingsState => {
  let list = null;
  let index = -1;

  switch (action.type) {
    case REQ_IMPORT_SETTING_LIST:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_IMPORT_SETTING_LIST:
      return {
        ...state,
        list: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_CREATE_IMPORT_SETTING:
      return {
        ...state,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_CREATE_IMPORT_SETTING:
      list = state.list.slice();
      list.push(action.response);

      return {
        ...state,
        list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_MATCH_IMPORT_SETTING:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_MATCH_IMPORT_SETTING:
      return {
        ...state,
        matches: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_REMOVE_IMPORT_SETTING:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_REMOVE_IMPORT_SETTING:
      list = state.list.slice();
      index = list.findIndex((is) => is.id === action.response.id);

      if (index >= 0) {
        list.splice(index, 1);
      }

      return {
        ...state,
        list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_UPDATE_IMPORT_SETTING:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_UPDATE_IMPORT_SETTING:
      list = state.list.slice();
      index = list.findIndex((is) => is.id === action.response.id);

      if (index >= 0) {
        list.splice(index, 1, action.response);
      }
      return {
        ...state,
        list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_BRANCH:
      return { ...state, list: [] };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default importsettingsReducer;
